/**
 * created by lei lei
 * 隔快组件
 * 高度自定义就是隔线
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class SpacerBlock extends Component {
    static defaultProps = {height: 20};
    static propTypes = {
        height: PropTypes.number,//快的高度默认是20，可以自定义
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div style={{height: this.props.height, background: '#f2f2f2'}}/>
        )
    }

}